import { BLAdmin, IReturnableActivity } from "types/working-model";
import ActivtyLogRow from "./activity-log-row";
import WaitingIndicator from "@general-ui/waiting-indicator/waiting-indicator";
import { OptionalComponent } from "utils/optional-component";

interface Props {
	activityLog: IReturnableActivity[];
	adminMap: Map<number, BLAdmin>;
	loadingMore: boolean;
}
export default function ActivityLog({ activityLog, adminMap, loadingMore }: Props) {
	return (
		<div className="activity-log">
			{activityLog.map((row, i) => <ActivtyLogRow activityLog={row} adminMap={adminMap} key={row.uuid + i} />)}
			<OptionalComponent display={loadingMore}>
				<div className="loading-more">
					<WaitingIndicator />
				</div>
			</OptionalComponent>
		</div>
	);
}